<template>
  <div class="layout-product-chars">
    <div v-if="loading" class="lds-ripple"><div></div><div></div></div>
    <template
        v-if="characteristics.length"
    >
      <table><tbody>
        <tr
            v-for="(character, index) in characteristics"
        >
          <td class="label">
            <span v-html="character.label"></span>
            <ui-help-tooltip v-if="character.hint" label="?" :width="400">
              <span v-html="character.hint"></span>
            </ui-help-tooltip>
          </td>
          <td class="value" :colspan="character.valueColspan">
            <template v-if="character.value">
              {{ character.value }}
              <ui-help-tooltip v-if="character.valueHint" label="?" :width="400">
                <span v-html="character.valueHint"></span>
              </ui-help-tooltip>
            </template>
            <template v-else-if="character.dopLink">
              <a
                  target="_blank"
                  style="text-decoration: underline; color: #f7990c;cursor:pointer;"
                  v-for="(dopLink, index) in character.dopLink"
                  :href="dopLink.link"
                  :title="dopLink.name">
                  <template v-if="dopLink.height">
                    {{ dopLink.height }}
                  </template>
                  <template v-else>
                    {{ dopLink.name }}
                  </template>
              </a>
            </template>
          </td>
          <td class="other" v-if="character.other">
            <span v-html="character.other"></span>
            <ui-help-tooltip v-if="character.otherHint" label="?" :width="400">
              <span v-html="character.otherHint"></span>
            </ui-help-tooltip>
          </td>
        </tr>
      </tbody></table>
    </template>


  </div>
</template>

<script>
export default {
  props: {
    prodid: null
  },
  data() {
    return {
      showMoreButton: null,
      loading: true,
      checkFetchProperty: false,
      keys: 1,
      characteristics: []
    }
  },
  methods: {
    init() {
      this.showMoreButton = this.$el.querySelector('.propertiesSloiMore')
      this.showMoreButton && (this.showMoreButton.onclick = this.showMore)
    },
    showMore() {
      const hiddens = document.querySelectorAll('.sloyHide')
      hiddens.forEach(hidden => {
        hidden.classList.add('active')
      })
      this.showMoreButton.classList.add('hidden')
    },
    fetchProperty(){
      if( !this.checkFetchProperty ) {
        this.$axios({
          url: '/ajax/propertydetails.php/?id=' + this.prodid + '&siteid=' + this.$store.state.siteid,
          method: 'post'
        }).then(response => {
          if (response.status == 200) {
            if(response.data) {
              this.characteristics = response.data;
              this.checkFetchProperty = true;
              this.keys=this.keys+1;
            }
            this.loading=false;
          }
        }).catch(e => {
          console.log('Error: ' + e)
          this.loading=false;
        });
      }
      this.sizeSelectOpened = !this.sizeSelectOpened;
    },
  },
  mounted() {
    if(!this.checkFetchProperty) {
      this.fetchProperty();
    }
    if (typeof (ym) === "function") {
      let yaCounterId = this.$store.state.langs.YACOUNTER;
      ym(yaCounterId, 'reachGoal', 'properties_block_open');
    }
    this.init()
  },
  components: {
    'ui-help-tooltip': () => import('@/components/ui/ui-help-tooltip'),
  },
  computed: {
    uiHelpTooltip() {
      return import('@/components/ui/ui-help-tooltip')
    }
  }
}
</script>

<style lang="scss">
.layout-product-chars {
  font-size: 16px;
  width: 100%;
  .label {
    font-weight: 700;
    text-transform: uppercase;
    font-size: 12px;
  }
  td {
    padding: 2px 8px;
  }
  tr,
  .sloi {
    &:nth-child(2n) {
      background: var(--light);
    }
  }
  .sloi {
    padding: 2px 8px;
  }
  .layer {
    background: none !important;
    td {
      padding: 0;
    }
    .label {
      padding: 2px 8px;
    }
  }
  .sloyHide {
    display: none;
    &.active {
      display: block;
    }
  }
  .propertiesSloiMore {
    background: var(--color);
    color: #fff;
    margin: 2px 8px;
    display: inline-block;
    padding: 10px 20px;
    border-radius: 6px;
    margin-top: 10px;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      background: var(--light);
      color: var(--color);
    }
    &.hidden {
      display: none;
    }
  }
  .fa {
    display: none;
  }
}
.propTab{}

/* loader */
.lds-ripple {
  display: inline-block;
  position: relative;
  /*left: 50%;*/
  top: -20px;
  width: 20px;
  height: 20px;
}
.lds-ripple div {
  position: absolute;
  border: 4px solid #dfc;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  4.9% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 0;
  }
  5% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}
</style>